/**
 * Zeitzonen zur Auswahl (Kalender, eigene Zone im Creator-Portal; Befund 15): übliche Zonen der DACH-Agenturen und
 * Drehorte zuerst, danach alle Zonen, die der Browser kennt (Intl.supportedValuesOf). Ohne Browser-Unterstützung
 * bleibt es bei der Grundliste.
 */
export const HAEUFIGE_ZONEN = [
  "Europe/Berlin", "Europe/Vienna", "Europe/Zurich", "Europe/London", "Europe/Paris", "Europe/Madrid", "Europe/Rome", "Europe/Amsterdam",
  "Europe/Stockholm", "Europe/Lisbon", "Europe/Athens", "Europe/Istanbul", "Asia/Singapore",
  "Asia/Tokyo", "Australia/Sydney", "America/New_York", "America/Chicago", "America/Los_Angeles", "America/Mexico_City", "America/Sao_Paulo",
  "Africa/Cape_Town", "UTC",
] as const;

export function alleZonen(): string[] {
  try {
    const f = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf;
    const list = f ? f("timeZone") : [];
    return list.length ? list : [...HAEUFIGE_ZONEN];
  } catch {
    return [...HAEUFIGE_ZONEN];
  }
}

/** Auswahl: eigene Werte zuerst (z. B. Zone des Termins, der Person, der Agentur), dann die häufigen, dann alle übrigen. */
export function zonenAuswahl(...eigene: (string | null | undefined)[]): { haeufig: string[]; alle: string[] } {
  const oben = [...new Set([...eigene.filter((z): z is string => !!z), ...HAEUFIGE_ZONEN])];
  const set = new Set(oben);
  return { haeufig: oben, alle: alleZonen().filter((z) => !set.has(z)) };
}

/** Anzeigename einer Zone: „Asia/Makassar (Bali)“ für bekannte Drehorte, sonst die Zone mit Leerzeichen. */
const ORTE: Record<string, string> = { "Australia/Sydney": "Sydney" };
export function zonenName(z: string): string {
  return ORTE[z] ? `${z.replace(/_/g, " ")} (${ORTE[z]})` : z.replace(/_/g, " ");
}
